module.exports = __webpack_public_path__ + "static/media/my-courses.2ab23cde.svg";